import React from 'react';

interface EmptyStatePanelProps {
  title: string;
  description: string;
}

const EmptyStatePanel: React.FC<EmptyStatePanelProps> = ({ title, description }) => (
  <div className="rounded-[28px] border border-dashed border-white/10 bg-white/4 px-6 py-10 text-center">
    <div className="text-3xl">•</div>
    <div className="mt-3 text-xl font-semibold text-white">{title}</div>
    <div className="mt-2 text-sm text-white/50">{description}</div>
  </div>
);

export default EmptyStatePanel;

